import { EventEmitter } from 'events';
export class NIMEventManager extends EventEmitter {
    constructor() {
        super();
        this.eventNameSet = new Set();
        this.setMaxListeners(99999);
    }
    repackageEvent(eventName, callback) {
        this.eventNameSet.add(eventName);
        this.on(eventName, callback);
        console.warn('eventsCount:', eventName, this.listenerCount(eventName));
        return callback;
    }
    getAllEvents() {
        const allEventsMap = {};
        Array.from(this.eventNameSet).forEach(name => {
            allEventsMap[name] = this.listeners(name)[0];
        });
        return allEventsMap;
    }
    cleanAllEvents() { }
    removeEvent() { }
}
export const imSession = new NIMEventManager();
